import { isObject } from '@cutwise/utils';

import { getCompareContextByType } from '@/comparison/helpers/getCompareContextByType';
import { CompareMapType, CompareStorageType } from '@/comparison/types';
import { ProductType } from '@/product/constants/productTypes';
import { ProductModel } from '@/product/entity/Product';
import ProductFactory from '@/product/entity/ProductFactory';

export default class ComparisonListSerializer {
  static serialize(productList: CompareMapType) {
    const jsonProductList: Record<string, number[]> = {};

    if (!isObject(productList)) {
      return jsonProductList;
    }

    Object.keys(productList).forEach((productType) => {
      const type = getCompareContextByType(productType as ProductType);

      if (productList[type]) {
        jsonProductList[type] = productList[type]!.map((item) => item.id);
      }
    });

    return jsonProductList;
  }

  static deserialize(jsonProductList: Nullable<CompareStorageType>): Partial<CompareMapType> {
    const productList: Partial<CompareMapType> = {};

    if (!jsonProductList || !isObject(jsonProductList)) {
      return productList;
    }

    const productTypes = Object.keys(jsonProductList);

    productTypes.forEach((productType) => {
      const type = getCompareContextByType(productType as ProductType);

      productList[type] = [];

      if (!jsonProductList[type]) {
        jsonProductList[type] = [];
      }

      jsonProductList[type]!.forEach((productId) => {
        productList[type]?.push(ProductFactory.make(type, { id: productId } as ProductModel));
      });
    });

    return productList;
  }
}
